import * as THREE from 'three';

const NUM_STARS = 3000;

const vertexShader = `
  attribute float size;
  attribute float brightness;
  varying float vBrightness;

  void main() {
    vBrightness = brightness;
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    gl_PointSize = size * (200.0 / -mvPosition.z);
    gl_Position = projectionMatrix * mvPosition;
  }
`;

const fragmentShader = `
  varying float vBrightness;

  void main() {
    float dist = length(gl_PointCoord - vec2(0.5));
    if (dist > 0.5) discard;

    float alpha = smoothstep(0.5, 0.0, dist) * vBrightness;
    vec3 color = mix(vec3(0.7, 0.8, 1.0), vec3(1.0, 0.95, 0.8), vBrightness * 0.3);
    gl_FragColor = vec4(color, alpha);
  }
`;

export class Starfield {
  constructor(scene) {
    const geometry = new THREE.BufferGeometry();
    const positions = new Float32Array(NUM_STARS * 3);
    const sizes = new Float32Array(NUM_STARS);
    const brightness = new Float32Array(NUM_STARS);
    this._baseBrightness = new Float32Array(NUM_STARS);
    this._twinkleSpeed = new Float32Array(NUM_STARS);
    this._twinklePhase = new Float32Array(NUM_STARS);

    for (let i = 0; i < NUM_STARS; i++) {
      positions[i * 3] = (Math.random() - 0.5) * 200;
      positions[i * 3 + 1] = (Math.random() - 0.5) * 200;
      positions[i * 3 + 2] = (Math.random() - 0.5) * 200;
      sizes[i] = Math.random() * 2 + 0.5;
      const b = Math.random() * 0.5 + 0.5;
      brightness[i] = b;
      this._baseBrightness[i] = b;
      this._twinkleSpeed[i] = Math.random() * 3 + 0.5;
      this._twinklePhase[i] = Math.random() * Math.PI * 2;
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    geometry.setAttribute('size', new THREE.BufferAttribute(sizes, 1));
    geometry.setAttribute('brightness', new THREE.BufferAttribute(brightness, 1));

    const material = new THREE.ShaderMaterial({
      vertexShader,
      fragmentShader,
      transparent: true,
      depthWrite: false,
      blending: THREE.AdditiveBlending,
    });

    this.points = new THREE.Points(geometry, material);
    scene.add(this.points);
    this._brightness = brightness;
    this._geometry = geometry;
  }

  update(time, highEnergy) {
    // Twinkle stars - more twinkle with high-frequency energy
    const twinkleIntensity = 0.3 + highEnergy * 2;
    for (let i = 0; i < NUM_STARS; i++) {
      const phase = this._twinklePhase[i] + time * this._twinkleSpeed[i];
      this._brightness[i] = this._baseBrightness[i] *
        (1 + Math.sin(phase) * twinkleIntensity * 0.3);
    }
    this._geometry.attributes.brightness.needsUpdate = true;

    // Slow camera drift
    this.points.rotation.y = time * 0.01;
    this.points.rotation.x = Math.sin(time * 0.005) * 0.05;
  }
}
